import React from 'react';
import { logError } from '@utils/usefulFuncs';
import { FlatButton } from './FlatButton';
import styled from 'styled-components';
import { Body7, Container } from '@ui';

const CopyButtonWrapper = styled.div`
  button {
    padding: 4px 16px;
  }
`;

export const CopyButton = ({ text }) => {
  const [isShowingCopied, setIsShowingCopied] = React.useState(false);

  const onCopyClick = () => {
    try {
      const textBlob = new Blob([text], { type: 'text/plain' });
      navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': textBlob,
        }),
      ]);
    } catch (e) {
      logError('failed clipboard, attempting fallback', e);
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    setIsShowingCopied(true);
  };

  React.useEffect(() => {
    if (isShowingCopied) {
      setTimeout(() => {
        setIsShowingCopied(false);
      }, 2600);
    }
  }, [isShowingCopied]);

  if (isShowingCopied) {
    return (
      <Container height={26} horizontal={9} centerAll>
        <Body7 bold>Copied to clipboard...</Body7>
      </Container>
    );
  }

  return (
    <CopyButtonWrapper>
      <FlatButton onClick={onCopyClick}>Copy Text</FlatButton>
    </CopyButtonWrapper>
  );
};
